import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {AiOutlineRight} from "react-icons/ai";
import _ from "lodash"
import {BsChevronRight, BsFolder, BsFolderFill} from "react-icons/bs";

export const renderSubCategory =
    ({renderContextMenu = NullAsDefault} = {}) =>
        (item, index) => {
            const {description} = item || {}
            return (
                <div key={index} className="p-4 flex items-center gap-3 custom-item-render relative list-item">
                    <BsFolderFill size={22} className="text-color-500"/>
                    <div className="flex flex-col flex-1">
                        <div className="flex items-center gap-1">
                            {!!_.get(item, 'parent') && (
                                <React.Fragment>
                                    <span className="text-base text-color-300 italic tracking-wide">
                                        {getTitle(_.get(item, 'parent'))}
                                    </span>
                                    <BsChevronRight size={12} className="text-color-300"/>
                                </React.Fragment>
                            )}
                            <span className="font-bold text-base text-color-000 tracking-wide">
                                {getTitle(item)}
                            </span>
                        </div>
                        {description && (
                            <span className="text-xs text-color-300 tracking-wider">
                            {description}
                        </span>
                        )}
                    </div>
                    {_.isFunction(renderContextMenu) && (
                        <div className="absolute right-5 top-5 contextIcon">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </div>
            )
        }
